import { coreMessages, type AppLocale } from './base-messages';

export const es: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: 'Operaciones de datos',
    operationExportExcel: 'Descargar Excel',
    operationDownloadTemplate: 'Descargar plantilla',
    operationUploadTemplate: 'Cargar plantilla',
    operationImportHistory: 'Historial de cargas',
    operationFieldDictionary: 'Diccionario de campos',
    operationUnsupported: 'Esta tabla no admite esta operación.',
    operationNoPermission: 'No tiene permiso para esta operación.',
    operationNotReady: 'Esta operación aún no está lista.',
    customFieldColumnsSectionLabel: 'Campos personalizados',
    importModalTitle: 'Subir plantilla',
    importChooseFile: 'Seleccionar archivo CSV',
    importChooseFileHint: 'Complete y suba la plantilla descargada desde esta tabla.',
    importNoFile: 'No se seleccionó ningún archivo.',
    importSummary: 'Resumen de importación',
    importReadyRows: 'Filas listas',
    importErrorRows: 'Filas con errores',
    importWarnings: 'Advertencias',
    importUnknownHeaders: 'Columnas desconocidas',
    importMissingRequiredHeaders: 'Columnas obligatorias faltantes',
    importPreview: 'Vista previa',
    importSubmit: 'Iniciar importación',
    importCancel: 'Cancelar',
    importParsing: 'Leyendo archivo...',
    importSubmitting: 'Importando...',
    importNoValidRows: 'No hay filas válidas para importar.',
    importFailed: 'La importación falló.',
    importSucceeded: 'Importación completada.',
    operationExportCsv: 'Descargar CSV',
    operationExportPdf: 'Descargar PDF',
    operationNoRows: 'No hay filas visibles para exportar.',
    importUnknownHeader: 'Columna desconocida: {header}',
    importMissingRequiredHeader: 'Falta la columna obligatoria: {header}',
    importRequiredCell: '{header} es obligatorio.',
    importMaxRowsExceeded: 'El archivo contiene más de {maxRows} filas; solo se evaluaron las primeras {maxRows}.',
    refreshLabel: 'Actualizar',
    focusModeEnterLabel: 'Enfocar tabla',
    focusModeFullscreenLabel: 'Abrir pantalla completa',
    focusModeExitLabel: 'Salir del enfoque de tabla',
    horizontalScrollLabel: 'Desplazar columnas de la tabla',
    selectionModeLabel: 'Seleccionar filas',
    selectAllRowsLabel: 'Seleccionar todas las filas',
    selectRowLabel: 'Seleccionar fila',
    bulkSelectedLabel: '{count} seleccionadas',
    bulkActionsLabel: 'Acciones masivas',
    tableSettingsLabel: 'Configuración de tabla',
    appearanceSectionLabel: 'Apariencia',
    columnsSectionLabel: 'Columnas',
    rowActionsLabel: 'Acciones de fila',
  },
  passwordReset: {
    title: 'Establecer una nueva contraseña',
    description: 'Elija una contraseña nueva y segura que solo usted conozca.',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    passwordHelp: 'Use al menos 12 caracteres y al menos tres tipos: minúscula, mayúscula, número y carácter especial.',
    mismatch: 'Las contraseñas no coinciden.',
    invalidLink: 'El enlace de restablecimiento falta, no es válido o ha caducado.',
    submit: 'Actualizar contraseña',
    submitting: 'Actualizando contraseña...',
    success: 'Su contraseña se ha actualizado. Ya puede iniciar sesión con la nueva contraseña.',
    backToLogin: 'Volver al inicio de sesión',
    requestTitle: 'Enviar enlace de restablecimiento',
    requestDescription: 'Se enviará un enlace de un solo uso, válido durante 30 minutos, al correo registrado del usuario. La contraseña actual no cambiará hasta que se utilice el enlace.',
    requestSend: 'Enviar enlace',
    requestSending: 'Enviando...',
    requestSuccess: 'El enlace de restablecimiento fue aceptado para su envío.',
    requestError: 'No se pudo enviar el enlace de restablecimiento.',
    selfServiceOpen: 'Olvidé mi contraseña',
    selfServiceTitle: 'Contraseña olvidada',
    selfServiceDescription: 'Introduzca el correo de su cuenta corporativa. Si coincide con una cuenta, se enviará un enlace de un solo uso válido durante 30 minutos.',
    selfServiceEmailLabel: 'Correo electrónico',
    selfServiceSubmit: 'Solicitar enlace',
    selfServiceSubmitting: 'Enviando solicitud...',
    selfServiceAcknowledgement: 'Si este correo está registrado, se enviará un enlace de restablecimiento. Revise su bandeja de entrada y la carpeta de spam.',
    selfServiceClose: 'Cerrar',
    selfServiceCancel: 'Cancelar',
    selfServiceError: 'No se pudo completar la solicitud. Inténtelo de nuevo más tarde.',
    selfServiceRateLimited: 'Demasiadas solicitudes. Inténtelo de nuevo más tarde.',
  },
  relationshipGraph: {
    sourceColumn: 'Origen',
    relationshipColumn: 'Relación',
    targetColumn: 'Registro vinculado',
    showDetails: 'Mostrar detalles',
    hideDetails: 'Ocultar detalles',
    controlsLabel: 'Controles del mapa',
    title: 'Mapa de relaciones',
    diagramLabel: 'Relaciones del registro',
    diagramHelp: 'Seleccione una tarjeta para examinar las conexiones registradas.',
    detailsTitle: 'Detalles del registro',
    connectionsTitle: 'Conexiones',
    noConnections: 'Sin conexiones',
    loading: 'Cargando relaciones…',
    forbidden: 'No tiene acceso a estas relaciones.',
    error: 'No se pudieron cargar las relaciones. Cierre e inténtelo de nuevo.',
    empty: 'Este registro no tiene conexiones que se puedan mostrar.',
    invalid: 'No se pudieron verificar las relaciones. Cierre e inténtelo de nuevo.',
    close: 'Cerrar mapa de relaciones',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    fitView: 'Ajustar mapa',
  },
  permissionPicker: {
    application: 'Aplicación',
    module: 'Módulo',
    action: 'Acción',
    permissions: 'Permisos',
    description: 'Descripción',
    selection: 'Selección',
    sharedPermissions: 'Permisos compartidos',
    selectedPermissions: '{count} permisos seleccionados',
    selectedOnly: 'Solo seleccionados',
    unselectedOnly: 'Solo no seleccionados',
    selectedFirst: 'Seleccionados primero',
    noPermissions: 'Sin permisos',
  },
  errors: {
    ...coreMessages.errors,
    unknown: 'Se produjo un error desconocido',
    network: 'No se puede conectar al servidor. Por favor, verifique su conexión a Internet.',
    timeout: 'Tiempo de espera agotado. Por favor, inténtelo de nuevo.',
    badRequest: 'Solicitud inválida',
    unauthorized: 'Su sesión ha expirado. Por favor, inicie sesión nuevamente.',
    forbidden: 'No tiene permiso para esta acción.',
    notFound: 'El recurso solicitado no se encontró',
    tooManyRequests: 'Demasiadas solicitudes enviadas. Por favor, inténtelo más tarde.',
    internalServerError: 'Error del servidor. Por favor, inténtelo más tarde.',
    badGateway: 'Servidor temporalmente no disponible',
    serviceUnavailable: 'Servicio temporalmente no disponible',
    gatewayTimeout: 'El servidor no responde',
    serverErrorWithStatus: 'Error del servidor ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: 'Nota para desarrolladores: En desarrollo local suele ocurrir si la VPN está apagada o la IP no está autorizada. Revise la VPN y el acceso a la base de datos.',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'No se puede conectar al servidor backend. Asegúrese de que el servidor esté funcionando ({apiUrl}).',
    backendConnectionErrorProd: 'No se puede conectar al servidor backend. Inténtelo más tarde.',
    systemUpdating: 'El sistema se está actualizando...',
    serverConfiguring: 'Configurando el servidor, por favor espere...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: 'Seleccionar',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
    edit: 'Editar',
    view: 'Ver',
    copy: 'Copiar',
    delete: 'Borrar',
    appLauncher: 'Aplicaciones',
    allApps: 'Todas las aplicaciones',
    loading: 'Cargando...',
    noData: 'Sin datos',
    code: 'Código',
    profileMenu: 'Menú de perfil',
    selectLanguage: 'Seleccionar idioma',
    perPage: 'Por página',
    firstPage: 'Primera página',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    lastPage: 'Última página',
    pleaseWait: 'Por favor espere',
    migrationDescription: 'Se está aplicando la actualización de la base de datos. Esto puede tardar unos segundos.',
    changeText: 'Cambiar',
    deleteLogo: 'Eliminar logo',
    logoUploadHint: 'Tamaño máximo: 5 MB. Formatos: JPEG, PNG, GIF, WebP',
    deleteAvatar: 'Eliminar foto de perfil',
    avatarUploadHint: 'Máx. 5 MB. JPEG, PNG, GIF, WebP.',
    newRecord: 'Nuevo registro',
    noPermission: 'No tiene permiso',
    searchPlaceholder: 'Buscar...',
    allStatuses: 'Todos los estados',
    active: 'Activo',
    inactive: 'Inactivo',
    clearFilters: 'Limpiar filtros',
    all: 'Todo',
    clickToChangeStatus: 'Haga clic para cambiar el estado',
    noChangePermission: 'No tiene permiso para cambiar el estado',
    statusDistribution: 'Distribución de estado',
    hide: 'Ocultar',
    show: 'Mostrar',
    companies: 'Companies',
    adminConsole: 'Consola de administración',
    manageAccount: 'Gestionar su cuenta',
    manageYourAccount: 'Administrar tu cuenta',
    notificationsTitle: 'Notificaciones',
    notificationsUnread: 'sin leer',
    notificationsTypesMuted: 'tipos silenciados',
    notificationsViewAll: 'Ver todo',
    notificationsPreferences: 'Preferencias',
    notificationsMutedLabel: 'Silenciado',
    notificationsEmpty: 'Sin notificaciones',
    selectAll: 'Seleccionar todo',
    id: 'ID',
    remove: 'Quitar',
    syncDeletedResult: '{count} entradas huérfanas eliminadas.',
    distributionByTable: 'Distribución por tabla (contexto)',
    distributionByLocale: 'Distribución por idioma',
    translationReport: 'Distribución del estado de traducción',
    page: 'Página',
    rows: 'filas',
    actions: 'Acciones',
    create: 'Crear',
    search: 'Buscar',
    closeSearch: 'Cerrar búsqueda',
    help: 'Ayuda',
    helpCenter: 'Centro de ayuda',
    helpAboutPage: 'Acerca de esta página',
    helpDocumentation: 'Documentación',
    helpKeyboardShortcuts: 'Atajos de teclado',
    helpWhatsNew: 'Novedades',
    helpF1Hint: 'Pulse F1 para obtener ayuda sobre esta página',
    helpNoDocsForPage: 'La documentación de esta página aún no está disponible',
    aiAssistantTitle: 'Asistente de IA de QubePro',
    aiAssistantButton: 'Asistente de IA',
    aiAssistantUnavailable: 'El asistente de IA no está disponible en este momento.',
    appearancePreference: 'Preferencia de apariencia',
    modalControlPlacement: 'Disposición de controles del formulario',
    modalControlPlacementHint: 'Define la posición de los controles de cerrar y pantalla completa en los formularios.',
    modalControlPlacementSystem: 'Sistema (recomendado)',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: 'Iniciar recorrido del producto',
      restart: 'Reiniciar recorrido del producto',
      navigationTitle: 'Barra lateral y módulos',
      navigationDescription: 'Use la barra lateral para acceder a los módulos y páginas autorizados y expandir o contraer cada sección.',
      appsTitle: 'Aplicaciones',
      appsDescription: 'Abra sus aplicaciones QubePro y cambie entre ellas desde aquí.',
      profileTitle: 'Perfil y empresa',
      profileDescription: 'Gestione aquí su perfil, la empresa seleccionada y sus preferencias de idioma.',
      aiTitle: 'QubePro AI',
      aiDescription: 'Abra el asistente de IA de QubePro para obtener ayuda sobre la página actual.',
      helpTitle: 'Centro de ayuda',
      helpDescription: 'Abra la documentación o reinicie este recorrido del producto en cualquier momento.',
      next: 'Siguiente',
      previous: 'Anterior',
      done: 'Finalizar',
      close: 'Cerrar',
      neverShowAgain: 'No volver a mostrar automáticamente',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: 'Extensiones',
    close: 'Cerrar',
    modalFocus: 'Enfocar formulario',
    modalFullscreen: 'Entrar en pantalla completa',
    modalRestore: 'Restaurar tamaño',
    filterByColumn: 'Filtrar por {column}',
    formCustomFieldsLoading: 'Cargando campos personalizados…',
    formCustomFieldsLoadError: 'No se pudieron cargar los campos personalizados. Vuelva a intentarlo antes de guardar para evitar la pérdida de datos.',
    formCustomFieldsRetry: 'Reintentar',
    pageUnavailableTitle: 'No se pudo abrir la página',
    pageUnavailableMessage: 'Puede abrir otra página desde el menú o actualizar esta página.',
    pageReloadWarning: 'Al actualizar se pierden los cambios sin guardar.',
    allTargetLanguages: 'Todos los idiomas (10 idiomas)',
    darkMode: 'Modo oscuro',
    lightMode: 'Modo claro',
    errorOccurred: 'Ocurrió un error',
    confirm: 'Confirmar',
    context: 'Tabla',
    key: 'Columna',
    originalShort: 'Orig.',
    originalValue: 'Valor original',
    locale: 'Idioma',
    value: 'Valor',
    status: 'Estado',
    auto: 'Auto',
    manual: 'Manual',
    manageLocales: 'Gestionar idiomas',
    updateUntranslatedFields: 'Sincronizar campos nuevos',
    autoTranslate: 'Traducción automática',
    sourceAndTargetMustDiffer: 'El idioma de origen y destino deben ser diferentes.',
    autoTranslateSuccessCount: '{count} elementos traducidos automáticamente.',
    syncEntriesResult: 'Sincronizadas {count} nuevas entradas de traducción.',
    translated: 'Translated',
    missing: 'Faltante',
    autoTranslateScope: 'Alcance de traducción automática',
    updateUntranslatedFieldsHint: 'Haga clic en "Actualizar campos nuevos" para sincronizar el contenido de estas tablas.',
    processing: 'Procesando...',
    enterTargetLanguage: 'Seleccionar idioma de destino.',
    sourceLanguage: 'Idioma de origen',
    selectLanguagesFirst: 'Primero seleccione idiomas en Gestionar idiomas',
    sourceLanguageLabel: 'Idioma de origen (su interfaz)',
    targetLanguage: 'Idioma de destino',
    activeLocalesDescription: 'Seleccionar idiomas activos. Solo se guarda como configuración.',
    selectSourceLanguageForSync: '¿En qué idioma están los contenidos?',
    languageNames: {
      en: 'Inglés',
      tr: 'Turco',
      de: 'Alemán',
      fr: 'Francés',
      es: 'Español',
      ar: 'Árabe',
      it: 'Italiano',
      ja: 'Japonés',
      zh: 'Chino',
      ru: 'Ruso',
    },
    warning: 'Advertencia',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'Error al iniciar sesión',
    emailRequired: 'El correo electrónico es obligatorio',
    passwordRequired: 'La contraseña es obligatoria',
    backendUnavailable: 'El servidor no está disponible. Inténtelo más tarde.',
    backendConnectFailed: 'No se puede conectar al servidor. Inténtelo más tarde.',
    backendConnectFailedDev: 'No se puede conectar al servidor. Compruebe que esté en ejecución ({apiUrl}).',
    emailLabel: 'Correo electrónico',
    emailPlaceholderFull: 'Ingrese su correo',
    passwordLabel: 'Contraseña',
    passwordPlaceholderFull: 'Introduzca la contraseña',
    hidePassword: 'Ocultar contraseña',
    showPassword: 'Mostrar contraseña',
    loggingIn: 'Iniciando sesión...',
    submitButton: 'Iniciar sesión',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'Correo electrónico o contraseña incorrectos. Por favor, inténtelo de nuevo.',
      sessionTooLarge: 'Los datos de sesión son demasiado grandes. Intente iniciar sesión de nuevo.',
      databaseUnavailable: 'La base de datos no está disponible o se requiere configuración. Inicie sesión de nuevo.',
      accountInactive: 'Su cuenta no está activa. Contacte con el administrador del sistema.',
      sessionExpired: 'Su sesión ha expirado. Inicie sesión de nuevo.',
      tooManyAttempts: 'Demasiados intentos. Inténtelo más tarde.',
    },
    featureTitle: "Conecte sus registros operativos y financieros",
    featureDescription: "Siga inventario, compras, ventas y registros financieros con QubePro ERP.",
    featureCard1Title: "Productos e inventario",
    featureCard1Description: "Gestione productos, almacenes y movimientos de inventario.",
    featureCard2Title: "Compras",
    featureCard2Description: "Siga documentos y pedidos de compra.",
    featureCard3Title: "Documentos de venta",
    featureCard3Description: "Gestione pedidos de venta y facturas.",
    featureCard4Title: "Movimientos financieros",
    featureCard4Description: "Revise registros bancarios, de caja y financieros.",
    darkMode: 'Modo oscuro',
    lightMode: 'Modo claro',
    pleaseWait: 'Espere por favor',
    serverConfiguring: 'Se está configurando el servidor, espere...',
    dbCreating: 'Se están creando la base de datos y las configuraciones necesarias. Este proceso puede tardar unos segundos.',
    loginPageTitle: 'Iniciar sesión',
    languageToggleLabel: 'Idioma',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'Panel de control',
    settings: 'Configuración',
    toggleMenu: 'Abrir menú',
    toggleMenuClose: 'Cerrar menú',
    companies: 'Empresas',
    logout: 'Cerrar sesión',
    activityLogs: 'Registros de actividad',
  },
  customFields: {
    title: 'Campos personalizados',
    newField: 'Nuevo campo personalizado',
    editField: 'Editar campo personalizado',
    entityType: 'Tipo de registro',
    code: 'Código de campo',
    label: 'Nombre visible',
    codePlaceholder: 'p. ej. nivelRiesgo',
    labelPlaceholder: 'p. ej. Código especial 1',
    dataType: 'Tipo de datos',
    type: 'Tipo',
    scope: 'Alcance',
    companyId: 'ID de empresa',
    companySelection: 'Empresas',
    companySelectionPlaceholder: 'Vacío es global, o seleccione empresas',
    selectedCompanies: '{{count}} empresas seleccionadas',
    selectAllCompanies: 'Seleccionar todas las empresas',
    sortOrder: 'Orden',
    required: 'Obligatorio',
    searchable: 'Buscable',
    showInForm: 'Mostrar en el formulario',
    showInList: 'Mostrar columna',
    formTab: 'Pestaña del formulario',
    formTabSelect: 'Pestaña del formulario',
    formTabPlaceholder: 'En blanco usa la pestaña Campos personalizados',
    defaultCustomTab: 'Campos personalizados',
    selectEntityTypeFirst: 'Seleccione primero el tipo',
    newFormTab: 'Nueva pestaña',
    tabCode: 'Código de pestaña',
    tabName: 'Nombre de pestaña',
    tabCodePlaceholder: 'p. ej. operaciones',
    tabNamePlaceholder: 'p. ej. Datos operativos',
    fieldWidth: 'Diseño de fila',
    widthFull: '1 campo por fila',
    widthHalf: '2 campos por fila',
    widthThird: '3 campos por fila',
    widthQuarter: '4 campos por fila',
    systemField: 'Campo del sistema',
    description: 'Descripción',
    options: 'Opciones',
    optionsPlaceholder: 'Cada línea: codigo:Etiqueta\nEjemplo: draft:Borrador\no solo Borrador',
    defaultValue: 'Valor predeterminado',
    statusDistributionTitle: 'Distribución de estado de {{title}}',
    emptyMessage: 'Aún no se han definido campos personalizados.',
    globalScope: 'Global',
    companyScope: 'Empresa {{id}}',
    deleteSelected: 'Eliminar seleccionados',
    deleteSelectedMessage: 'Se eliminarán {{count}} campos personalizados. Esta acción no se puede deshacer.',
    formDesigner: 'Diseño de formulario',
    formDesignerTitle: 'Diseño de campos personalizados',
    formDesignerEntityType: 'Tipo de registro a diseñar',
    formDesignerAllTabs: 'Todos',
    formDesignerEmpty: 'No hay campos personalizados para este tipo de registro.',
    formDesignerOriginalNotice: 'Los campos originales del formulario se conservan; esta pantalla gestiona pestañas, orden y diseño de filas de los campos personalizados.',
    formDesignerSave: 'Guardar diseño',
    formDesignerSaved: 'Diseño de formulario guardado.',
    formDesignerMoveUp: 'Mover arriba',
    formDesignerMoveDown: 'Mover abajo',
    formDesignerFieldSettings: 'Diseño del campo',
    formDesignerQuickSave: 'Guardar',
    formDesignerEditTab: 'Editar pestaña',
    formDesignerDeleteTab: 'Eliminar pestaña',
    formDesignerTabEditorTitle: 'Configuración de pestaña',
    formDesignerCloseTabEditor: 'Cerrar editor de pestaña',
    dataTypes: {
      text: 'Texto',
      number: 'Número',
      date: 'Fecha',
      datetime: 'Fecha/hora',
      boolean: 'Sí/No',
      select: 'Selección',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: 'Registros de actividad',
    searchPlaceholder: 'Buscar (entidad, módulo, acción)…',
    allModules: 'Todos los módulos',
    allActions: 'Todas las acciones',
    allSeverity: 'Todas las gravedades',
    allApps: 'Todas las aplicaciones',
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
    exportCsv: 'Exportar CSV',
    total: 'Total',
    today: 'Hoy',
    critical: 'Crítico',
    warning: 'Advertencia',
    severityInfo: 'Info',
    exportFilenameStem: 'registros-actividad',
    noLogs: 'No se encontraron registros de actividad.',   system: 'Sistema',
    field: 'Campo',
    oldValue: 'Valor anterior',
    newValue: 'Valor nuevo',
    ip: 'IP',
    meta: 'Metadatos de la petición',
    userAgent: 'User-Agent',
    entity: 'Entidad',
    severityCol: 'Gravedad',
    userCol: 'Usuario',
    actionCol: 'Acción',
    moduleCol: 'Módulo',
    dateCol: 'Fecha',
    appCol: 'Aplicación',
    overviewTitle: 'Resumen',
    severityChart: 'Distribución de gravedad',
    topModulesChart: 'Módulos principales por volumen',
    csvId: 'ID',
    csvDate: 'Fecha',
    csvUser: 'Usuario',
    csvAction: 'Acción',
    csvModule: 'Módulo',
    csvEntity: 'Entidad',
    csvSeverity: 'Gravedad',
    csvIp: 'IP',
    csvApplication: 'Aplicación',
    companyCol: 'ID de empresa',
    allOutcomes: 'Todos los resultados',
    noLogsDesc: 'Los registros aparecerán aquí cuando los usuarios realicen acciones.',
    entityType: 'Tipo de registro',
    actorType: 'Tipo de actor',
    outcome: 'Resultado',
    successful: 'Correcto',
    failed: 'Fallido',
    denied: 'Denegado',
    reason: 'Motivo',
    requestId: 'ID de solicitud',
    correlationId: 'ID de correlación',
    integrity: 'Prueba de integridad',
    outboxWarning: 'La cola de entrega de auditoría requiere atención.',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'Notificaciones',
    tabPreferences: 'Preferencias',
    markAllRead: 'Marcar todas como leídas',
    notifCount: '{total} notificaciones',
    unreadCount: '{count} sin leer',
    loading: 'Cargando notificaciones...',
    noNotifications: 'Sin notificaciones',    markRead: 'Marcar como leída',
    delete: 'Eliminar',   noPreferences: 'Sin preferencias',
    noPreferencesDesc: 'Aún no hay categorías de notificación. Las preferencias se crean automáticamente al recibir notificaciones.',
    preferencesHeader: 'Preferencias de notificaciones en la app',
    prefItemDesc: 'Recibir notificaciones de esta categoría dentro de la app',
    readDistribution: 'Distribución del estado de lectura',
    readStatusLabel: 'Estado de lectura',
    filterAll: 'Todas',
    filterUnread: 'No leídas',
    filterRead: 'Leídas',    colType: 'Tipo',
    colTitle: 'Título',
    colMessage: 'Mensaje',
    colDate: 'Fecha',
    colRead: 'Estado',
    statusUnread: 'No leída',
    statusRead: 'Leída',
    searchNotifications: 'Buscar en título o mensaje…',
  },
};
